import { TIME_BLOCKS } from '../lib/constants'
import BlockTimer from '../components/BlockTimer'

export default function DailyTracking({ userId }) {
  const [date] = useState(() => {
    const now = new Date()
    const offset = now.getTimezoneOffset() * 60000
    return new Date(now.getTime() - offset).toISOString().split('T')[0]
  })
  const [blocks, setBlocks] = useState({})
  const [saving, setSaving] = useState(false)

  // 加载今日数据
  useEffect(() => {
    if (!userId) return
    fetchToday()
  }, [userId, date])

  const fetchToday = async () => {
    const { supabase } = await import('../lib/supabase')
    const { data, error } = await supabase
      .from('gaokao_daily_blocks')
      .select('*')
      .eq('user_id', userId)
      .eq('date', date)

    if (!error && data) {
      const map = {}
      data.forEach(b => map[b.block_id] = b)
      setBlocks(map)
    }
  }

  const handleBlockComplete = async ({ action, blockId, duration, subject, focusScore }) => {
    setSaving(true)
    const { supabase } = await import('../lib/supabase')
    const block = TIME_BLOCKS.find(b => b.id === blockId)

    if (action === 'start') {
      const { data, error } = await supabase
        .from('gaokao_daily_blocks')
        .upsert({
          user_id: userId,
          date,
          block_id: blockId,
          block_name: block.name,
          start_time: new Date().toISOString(),
          subject: null,
        })
        .select()
        .single()

      if (!error && data) setBlocks(prev => ({ ...prev, [blockId]: data }))
    }

    if (action === 'end') {
      const { data, error } = await supabase
        .from('gaokao_daily_blocks')
        .update({
          end_time: new Date().toISOString(),
          subject,
          focus_score: focusScore,
          completed: true,
        })
        .eq('user_id', userId)
        .eq('date', date)
        .eq('block_id', blockId)
        .select()
        .single()

      if (!error && data) setBlocks(prev => ({ ...prev, [blockId]: data }))
    }

    setSaving(false)
  }

  // 统计今日数据
  const todayStats = Object.values(blocks).filter(b => b.completed)
  const totalMinutes = todayStats.reduce((sum, b) => {
    if (b.start_time && b.end_time) {
      const start = new Date(b.start_time)
      const end = new Date(b.end_time)
      return sum + Math.floor((end - start) / 60000)
    }
    return sum
  }, 0)
  const avgFocus = todayStats.length > 0
    ? (todayStats.reduce((sum, b) => sum + (b.focus_score || 0), 0) / todayStats.length).toFixed(1)
    : 0

  return (
    <div className="max-w-3xl mx-auto p-4">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">{date} 每日追踪</h1>
        <p className="text-sm text-ink-500 dark:text-ink-300 mt-1">
          已完成 {todayStats.length}/{TIME_BLOCKS.length} 个时段 · 共 {totalMinutes} 分钟 · 平均专注度 {avgFocus}/10
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {TIME_BLOCKS.map(block => (
          <BlockTimer
            key={block.id}
            block={{
              ...block,
              ...blocks[block.id],
            }}
            onComplete={handleBlockComplete}
          />
        ))}
      </div>
    </div>
  )
}
